import { render, staticRenderFns } from "./NoteButton.vue?vue&type=template&id=163e7dde"
import script from "./NoteButton.vue?vue&type=script&lang=js"
export * from "./NoteButton.vue?vue&type=script&lang=js"
import style0 from "./NoteButton.vue?vue&type=style&index=0&id=163e7dde&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163e7dde')) {
      api.createRecord('163e7dde', component.options)
    } else {
      api.reload('163e7dde', component.options)
    }
    module.hot.accept("./NoteButton.vue?vue&type=template&id=163e7dde", function () {
      api.rerender('163e7dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/NoteButton.vue"
export default component.exports